import React, { Component } from 'react';
import { createApolloFetch } from 'apollo-fetch';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import * as compose from 'lodash.flowright';
import { gql } from 'apollo-boost';

import { name, description, salary, validateForm } from '../../../validations/validation'
// styles , icons and images
import { Container, Row, Col, Form } from 'react-bootstrap';
import {
    TextField, InputLabel, Button, Chip,
    Typography, FormControl, Select, MenuItem
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';

// this component represents the create and edit  job 

class JobOverview extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tagsChoosen: []
        }
    }
    componentWillReceiveProps(currentProps, nextProps) {
        //handle props that receive on the edit 
        if (currentProps.data) {
            let data = currentProps.data;
            console.log(data)
            console.log(data.id)
            this.setState({
                ...this.state, 
                jobId: data.jobId,
                title: data.title, brief: data.brief,
                tagsChoosen: data.tagsChoosen,
                salaryFrom: data.salaryFrom,
                salaryTo: data.salaryTo,
                experience: data.experience,
                jobType: data.jobType ,
                jobStatus : data.jobStatus,
                questions : data.questions,
                currency: data.currency
            });

        }

    }
    componentWillMount() {
        //handle fetch specialities and tags dropdown   
        const token = JSON.parse(localStorage.getItem('jwt')).BearerTokenResponse.access_token;
        const uri = 'https://spreago.black-squares.com/graphql';
        const apolloFetch = createApolloFetch({ uri });
        apolloFetch.use(({ request, options }, next) => {
            if (!options.headers) {
                options.headers = {};  // Create the headers object if needed.
            }
            options.headers['authorization'] = `Bearer ${token}`;

            next();
        });
        //get tags
        apolloFetch({
            query:
                `query{
                tag{
                  id
                  name
                 
                }
              }
            `,
        }).then(res => {
            if (res.data.tag) {
                this.setState({ ...this.state, tags: res.data.tag });
            }
        });
        //get specialites
        // apolloFetch({
        //     query:
        //         `query{
        //     specialities{
        //         id
        //         context
        //         name
        //         name_en
        //         name_ar
        //         created_at
        //         updated_at
                
        //     }
        //     }
        // `,
        // }).then(res => {
        //     if (res.data.specialities) {
        //         this.setState({ ...this.state, specialities: res.data.specialities });
        //     }
        // });
        //get job types
        apolloFetch({
            query:
                `query{
                    jobTypes{
                        id
                        name
                        name_en
                        name_ar
                    }
                    }
            `,
        }).then(res => {
            if (res.data.jobTypes) {
                this.setState({ ...this.state, jobTypes: res.data.jobTypes });
            }
        });
        //get job types
        apolloFetch({
            query:
                ` query{
                  JobLevelOfExperienceTypes{
                    id
                    context
                    name
                    name_en
                    name_ar
                  }
                }
            `,
        }).then(res => {

            if (res.data.JobLevelOfExperienceTypes) {
                this.setState({ ...this.state, experiences: res.data.JobLevelOfExperienceTypes });
            }
        });
        //get currency
        apolloFetch({
            query:
                `query{
                  currencyTypes{
                    id
                    code
                    symbol
                    symbol_native
                  }
                }
            `,
        }).then(res => {
            if (res.data.currencyTypes) {
                this.setState({ ...this.state, currencyTypes: res.data.currencyTypes });
            }
        });
    }
    capitalFirstChar = (string) => {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    render() {
        const handleChangeSalary = prop => event => {
            this.setState({ ...this.state, [prop]: event.target.value , salaryErrorMessage : ''});
        }
        // input validation
        const checkTitle = prop => event => {
            let error = name(event.target.value)
            this.setState({ ...this.state, errorMessage: error, [prop]: event.target.value });
        }
        const checkBrief = prop => event => {
            let error = description(event.target.value);
            this.setState({ ...this.state, briefErrorMessage: error, [prop]: event.target.value });

        }
        const checkSpeciality = prop => event => {
            let specialitychoosen = [];
            specialitychoosen = this.state.specialities.filter((speciality) => {
                return speciality.id === event.target.value
            });
            if (specialitychoosen.length > 0) {
                this.setState({ ...this.state, specialityErrorMessage: "", [prop]: specialitychoosen[0].id })
            }
            else if (specialitychoosen.length === 0) {

                this.setState({ ...this.state, specialityErrorMessage: "This field is required.", [prop]: specialitychoosen[0].id })
            }
            else {
                this.setState({ ...this.state, speciality: '', [prop]: specialitychoosen[0].id })
            }
        }
        const checkSalary = (salaryfrom, salaryTo) => {
            let error = salary(salaryfrom, salaryTo);
            if(error){
                this.setState({ ...this.state, salaryErrorMessage: error });
                return false
            }
        }
        const CheckJobType = prop => event => {
            if (event.target.value === null || event.target.value === undefined) {
                this.setState({ ...this.state, jobTypeErrorMessage: 'This field is required', [prop]: event.target.value });
            }
            else {
                this.setState({ ...this.state, jobTypeErrorMessage: '', [prop]: event.target.value });
            }
        }
        const checkCurrency = props => event => {
            if (event.target.value === null || event.target.value === undefined) {
                this.setState({ ...this.state, currencyErrorMessage: 'This field is required', [props]: event.target.value });
            }
            else {
                this.setState({ ...this.state, currencyErrorMessage: '', [props]: event.target.value });
            }
        }
        const CheckExperience = prop => event => {
            if (event.target.value === null || event.target.value === undefined) {
                this.setState({ ...this.state, experienceErrorMessage: 'This field is required', [prop]: event.target.value });
            }
            else {
                this.setState({ ...this.state, experienceErrorMessage: '', [prop]: event.target.value });
            }
        }
        const checkRequired = () => {
            let formIsValid = true;
            // check name
            if (this.state.title === undefined || this.state.title.length < 3 || this.state.title.length > 191) {
                this.setState({ ...this.state, errorMessage: 'This field is required.' });
                formIsValid = false;
            }
            // check description
            if (this.state.brief === null || this.state.brief === '' || this.state.brief === undefined) {
                this.setState({ ...this.state, briefErrorMessage: 'This field is required.' });
                formIsValid = false;
            }
            else if (this.state.brief.length > 5000) {
                this.setState({ ...this.state, briefErrorMessage: 'This field is required.' });
                formIsValid = false;
            }
            // check speciality
            // let specialitychoosen = [];
            // specialitychoosen = this.state.specialities.filter((speciality) => {
            //     return speciality.id === this.state.speciality
            // });
            // if (specialitychoosen.length > 0) {
            //     this.setState({ ...this.state, specialityErrorMessage: "", speciality: specialitychoosen[0].id })
            // }
            // else if (specialitychoosen.length === 0) {
            //     this.setState({ ...this.state, specialityErrorMessage: "This field is required." })
            //     formIsValid = false;
            // }
            // check tags
            if (this.state.tagsChoosen.length === 0) {
                this.setState({ ...this.state, tagsErrorMessage: 'This field is required' });
                formIsValid = false;
            }

            // check jobType
            if (!this.state.jobType || this.state.jobType === null || this.state.jobType === undefined) {
                this.setState({ ...this.state, jobTypeErrorMessage: 'This field is required' });
                formIsValid = false;
            }
            // check experience 
            if (this.state.experience === null || this.state.experience === undefined) {
                this.setState({ ...this.state, experienceErrorMessage: 'This field is required' });
                formIsValid = false;
            }
            // check salary
            if(salary(this.state.salaryFrom, this.state.salaryTo)){
                let error = salary(this.state.salaryFrom, this.state.salaryTo);
                this.setState({ ...this.state, salaryErrorMessage: error });
                formIsValid = false;
            }
            // check experience 
            if (this.state.currency === null || this.state.currency === undefined) {
                this.setState({ ...this.state, currencyErrorMessage: 'This field is required' });
                formIsValid = false;
            }

            return formIsValid;
        }
        return (
            <div className="pb-3 overview-tap">
                <Form>
                    <Container className="overview shadow border-rounded">
                        <Row>
                            <Col className="border-bottom bg-light p-5" sm={12}>
                                <div className="title">
                                    <h4 className="text-dark">Overview</h4>
                                    <p className="text-grey mb-0">Provide the applicant with your job main Information</p>
                                </div>
                            </Col>
                            <Col sm={12} className="bg-white p-5">
                                <div className="">
                                    <InputLabel htmlFor="title">
                                        Title<span className="text-danger"> *</span>
                                    </InputLabel>
                                    <TextField
                                        required
                                        id="title"
                                        name="title"
                                        value={this.state.title}
                                        onChange={checkTitle('title')}
                                        placeholder="Write your title"
                                        fullWidth
                                        variant="outlined"
                                        className="pt-1"
                                    />
                                    <Col xs={12} className="p-0  pb-3">
                                        <Typography variant="subtitle1" className="text-danger">{this.state.errorMessage}</Typography>
                                    </Col>
                                </div>
                                <div className=" pb-3">
                                    <InputLabel htmlFor="brief">
                                        Brief<span className="text-danger"> *</span>
                                    </InputLabel>
                                    <TextField
                                        required
                                        name="brief"
                                        id="brief"
                                        className="pt-1"
                                        value={this.state.brief}
                                        onChange={checkBrief('brief')}
                                        multiline
                                        rows="7"
                                        fullWidth
                                        variant="outlined"
                                        placeholder="Write your Brief"
                                        helperText="0 / 5000 Characters"
                                    />
                                    <Col xs={12} className="p-0">
                                        <Typography variant="subtitle1" className="text-danger">{this.state.briefErrorMessage}</Typography>
                                    </Col>
                                </div>
                                <div className="pb-3">
                                    <InputLabel htmlFor="tags">
                                        Related tags<span className="text-danger"> *</span>
                                    </InputLabel>
                                    <Autocomplete
                                        required
                                        className="pt-1"
                                        multiple
                                        id="tags"
                                        value={this.state.tagsChoosen}
                                        onChange={(event, value) => {
                                            if (value.length === 0) {
                                                this.setState({ ...this.state, tagsErrorMessage: 'This field is required', tagsChoosen: value });
                                            }
                                            else {
                                                this.setState({ ...this.state, tagsErrorMessage: '', tagsChoosen: value });
                                            }
                                        }}
                                        options={this.state.tags?.map(option => option.name)}
                                        freeSolo
                                        renderTags={(value, getTagProps) =>
                                            value.map((option, index) => (
                                                <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                                            ))
                                        }
                                        renderInput={params => (
                                            <TextField {...params} variant="outlined" />
                                        )}
                                    />
                                    <Col xs={12} className="p-0">
                                        <Typography variant="subtitle1" className="text-danger">{this.state.tagsErrorMessage}</Typography>
                                    </Col>
                                </div>
                                {/* <div className="pb-3">
                                    <InputLabel htmlFor="speciality">
                                        Speciality<span className="text-danger"> *</span>
                                    </InputLabel>
                                    <FormControl
                                        required
                                        id="speciality"
                                        name="speciality"
                                        className="pt-1"
                                        fullWidth
                                        variant="outlined">
                                        <Select
                                            inputProps={{ value: this.state.speciality ? this.state.speciality : '' }}
                                            onChange={checkSpeciality('speciality')}
                                        >
                                            {this.state.specialities?.map(item =>
                                                <MenuItem className="captialize" key={item.id} value={item.id}>{item.name}</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                    <Col xs={12} className="p-0">
                                        <Typography variant="subtitle1" className="text-danger">{this.state.specialityErrorMessage}</Typography>
                                    </Col>
                                </div> */}
                                <div className="pb-3">
                                    <InputLabel htmlFor="jobtype-select">
                                        Job type<span className="text-danger">*</span>
                                    </InputLabel>
                                    <FormControl
                                        required
                                        id="jobtype-select"
                                        className="pt-1"
                                        fullWidth
                                        variant="outlined">
                                        <Select
                                            inputProps={{ value: this.state.jobType ? this.state.jobType : '' }}
                                            onChange={CheckJobType('jobType')}
                                        >
                                            {this.state.jobTypes?.map(item =>
                                                <MenuItem className="captialize" key={item.id} value={item.id}>{item.name}</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                    <Col xs={12} className="p-0">
                                        <Typography variant="subtitle1" className="text-danger">{this.state.jobTypeErrorMessage}</Typography>
                                    </Col>
                                </div>
                                <div className="pb-3 ">
                                    <InputLabel htmlFor="experience-select">
                                        Level of experience<span className="text-danger"> *</span>
                                    </InputLabel>
                                    <FormControl
                                        required
                                        id="experience-select"
                                        className="pt-1"
                                        fullWidth
                                        variant="outlined">
                                        <Select
                                            inputProps={{ value: this.state.experience ? this.state.experience : ''}}
                                            onChange={CheckExperience('experience')}
                                        >
                                            {this.state.experiences?.map(item =>
                                                <MenuItem key={item.id} value={item.id}>{item.name}</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                    <Col xs={12} className="p-0">
                                        <Typography variant="subtitle1" className="text-danger">{this.state.experienceErrorMessage}</Typography>
                                    </Col>
                                </div>
                                <div className="pb-3 ">
                                    <InputLabel htmlFor="currency-select">
                                        Currency<span className="text-danger"> *</span>
                                    </InputLabel>
                                    <FormControl
                                        required
                                        id="currency-select"
                                        className="pt-1"
                                        fullWidth
                                        variant="outlined">
                                        <Select
                                            inputProps={{ value: this.state.currency ? this.state.currency : ''}}
                                            onChange={checkCurrency('currency')}
                                        >
                                            {this.state.currencyTypes?.map(item =>
                                                <MenuItem key={item.id} value={item.id}>{item.code}</MenuItem>
                                            )}
                                        </Select>
                                    </FormControl>
                                    <Col xs={12} className="p-0">
                                        <Typography variant="subtitle1" className="text-danger">{this.state.currencyErrorMessage}</Typography>
                                    </Col>
                                </div>
                                <div className="row m-0 w-100">
                                    <Col xs={12} className="p-0">
                                        <InputLabel htmlFor="Salary">
                                            Salary Range<span className="text-danger">*</span>
                                        </InputLabel>
                                    </Col>
                                    <Col className="p-0 pr-1">
                                        <TextField
                                            required
                                            id="salaryFrom"
                                            name="salaryFrom"
                                            type="number"
                                            value={this.state.salaryFrom}
                                            onChange={handleChangeSalary('salaryFrom')}
                                            inputProps={{
                                                min: 1
                                            }}
                                            placeholder="From"
                                            variant="outlined"
                                            className="pt-1 w-100"
                                        />
                                    </Col>
                                    <Col className="p-0 pl-1">
                                        <TextField
                                            required
                                            id="salaryTo"
                                            name="salaryTo"
                                            type="number"
                                            value={this.state.salaryTo}
                                            onChange={handleChangeSalary('salaryTo')}
                                            placeholder="To"
                                            inputProps={{
                                                min: 1
                                            }}
                                            variant="outlined"
                                            className="pt-1 w-100"
                                        />
                                    </Col>
                                    <Col xs={12} className="p-0 pb-3">
                                        <Typography variant="subtitle1" className="text-danger">{this.state.salaryErrorMessage}</Typography>
                                    </Col>
                                </div>
                                <Col xs={12} className="p-0 pb-3">
                                    <Typography variant="subtitle1" className="text-danger">{this.state.ConnectionErorr}</Typography>
                                </Col>
                            </Col>
                        </Row>
                    </Container>
                    <Row>
                        <Col className="pt-4 text-left text-responsive-center">
                            <Button size="large" className="btn-white-outline pr-5 pl-5" variant="contained" to="#" >Cancel</Button>
                        </Col>
                        <Col className="pt-4 text-right">
                            <Button
                                type="submit"
                                size="large"
                                className="btn-orange-gradiant pr-5 pl-5"
                                variant="contained"
                                onClick={e => {
                                    e.preventDefault();
                                    if ( checkRequired()) {
                                        this.props.callBackFun(this.state);
                                        window.scrollTo({ top: 0, behavior: 'smooth' });
                                        let list = document.getElementById("job-tabs");
                                        let nav_items = list.querySelectorAll(".nav-item a");
                                        nav_items[1].click();
                                        // before edits
                                        // if (this.state.jobId) {
                                        //     this.props.editJob({
                                        //         variables: {
                                        //             job_id: this.state.jobId,
                                        //             title: this.state.title,
                                        //             brif: this.state.brief ? this.state.brief : '',
                                        //             job_type_id: this.state.jobType ? this.state.jobType : '',
                                        //             job_level_of_experience_type_id: this.state.experience ? this.state.experience : '',
                                        //             tags: this.state.tagsChoosen ? this.state.tagsChoosen : [],
                                        //             salary_from: this.state.salaryFrom ? this.state.salaryFrom : '',
                                        //             salary_to: this.state.salaryTo ? this.state.salaryTo : '',
                                        //             job_status_id: this.state.jobStatus ? this.state.jobStatus : 1,
                                        //             specialities_id: this.state.speciality
                                        //         }
                                        //     }).then((res, loading) => {
                                        //         if (res.data.jobEdit.Status.code === 200) {
                                        //             this.props.callBackFun(res.data.jobEdit.job);
                                        //             window.scrollTo({ top: 0, behavior: 'smooth' });
                                        //             let list = document.getElementById("job-tabs");
                                        //             let nav_items = list.querySelectorAll(".nav-item a");
                                        //             nav_items[1].click();
                                        //         }
                                        //     }).catch((err) =>
                                        //         console.log(err)
                                        //         //this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." })
                                        //     )
                                        // } else {
                                        //     this.props.createJob({
                                        //         variables: {
                                        //             title: this.state.title,
                                        //             brif: this.state.brief ? this.state.brief : '',
                                        //             job_type_id: this.state.jobType ? this.state.jobType : '',
                                        //             job_level_of_experience_type_id: this.state.experience ? this.state.experience : '',
                                        //             tags: this.state.tagsChoosen ? this.state.tagsChoosen : [],
                                        //             salary_from: this.state.salaryFrom ? this.state.salaryFrom : '',
                                        //             salary_to: this.state.salaryTo ? this.state.salaryTo : '',
                                        //             questionInputs: [],
                                        //             job_status_id: 1,
                                        //             is_Draft: true,
                                        //             specialities_id: this.state.speciality

                                        //         }
                                        //     }).then((res, loading) => {
                                        //         if (res.data.jobCreate.Status.code === 200) {
                                        //             this.props.callBackFun(res.data.jobCreate.job);
                                        //             window.scrollTo({ top: 0, behavior: 'smooth' });
                                        //             let list = document.getElementById("job-tabs");
                                        //             let nav_items = list.querySelectorAll(".nav-item a");
                                        //             nav_items[1].click();
                                        //         }
                                        //     }).catch((err) =>
                                        //         console.log(err)
                                        //         //  this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." })
                                        //     )
                                        // }
                                    }
                                }}
                            >Next</Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}
export default withRouter(JobOverview);
